import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cityComponent from './city.component';
import CityService from './city.service';

let cityModule = angular.module('city', [
  uiRouter
])

.service('City', CityService)

.component('city', cityComponent)

.name;

export default cityModule;



// WEBPACK FOOTER //
// ./client/app/components/city/city.js